<script setup lang="ts">

import { defineProps } from 'vue'

defineProps({
  width: {
    type: String,
    required: true,
  },
  align: {
    type: String,
    default: 'center',
  }
});

</script>

<template>
  <div
    :style="{ width: width + 'rem' }"
    :class="'flex items-center justify-' + align + ''">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">

</style>